import { createSelector } from "@reduxjs/toolkit"

export const getUserToken = state => state.session.token

export const getUser = state => state.session.user

export const getError = state => state.session.error

export const isLoggedIn = createSelector(getUserToken, token => !!token)
